import { useState, useEffect } from 'react';
import { ReadingsService } from 'src/services/readings/readings.service';
import { subHours } from 'date-fns';
import { LatestReadingsResponse, LatestReadingWithDisplay } from 'src/types/readings/readings';
import { useAuthentication } from 'src/features/authentication/context';

type UseGatewayReadingsArgs = {
  gatewayId?: string;
  tagId?: string;
  isOnChange?: boolean;
};

export const useGatewayReadings = ({ gatewayId, tagId, isOnChange }: UseGatewayReadingsArgs) => {
  const {
    customerId: { value: customerId },
  } = useAuthentication();
  const [readings, setReadings] = useState<LatestReadingsResponse>({});
  const [isDataReady, setIsDataReady] = useState<boolean>(false);
  const [endDate, setEndDate] = useState<string | null>(null);

  const display = readings && (readings[tagId!] as LatestReadingWithDisplay)?.display;

  useEffect(() => {
    if (!gatewayId || !tagId) return;

    const controller = new AbortController();

    const now = new Date();
    const startDate = subHours(now, 3).toISOString();
    const currentEndDate = now.toISOString();
    setEndDate(currentEndDate);

    ReadingsService.getReadingsNewDataStorage({
      customerId: customerId!,
      gatewayId: gatewayId,
      startDate: startDate,
      endDate: currentEndDate,
      measurements: tagId,
      aggregationType: null,
      includeDisplayConfig: true,
      isOnChange,
    })
      .then((res) => {
        if (!controller.signal.aborted) {
          setReadings(res.data);
        }
      })
      .catch((error) => {
        if (!controller.signal.aborted) {
          console.error(error);
        }
      })
      .finally(() => {
        if (!controller.signal.aborted) {
          setIsDataReady(true);
        }
      });

    return () => {
      controller.abort();
    };
  }, [tagId, gatewayId, customerId, isOnChange]);

  return { readings, isDataReady, display, endDate };
};
